import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a8ad155"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"background":"#fff","margin-top":"20px","border-radius":"4px"},
  class: "qualification"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titleBox" }, "资质认证", -1))
const _hoisted_3 = {
  key: 0,
  class: "centerBox"
}
const _hoisted_4 = { class: "upload-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "点击上传", -1))
const _hoisted_6 = {
  key: 1,
  class: "imgBox"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_8 = { class: "editBox" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"12px","color":"#999"} }, "|", -1))
const _hoisted_10 = { class: "span" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "支持PNG或JPG格式，大小应小于5M", -1))
const _hoisted_12 = { class: "forItem" }
const _hoisted_13 = { class: "forItem" }
const _hoisted_14 = { class: "forItem" }
const _hoisted_15 = { class: "forItem" }
const _hoisted_16 = { class: "forItem" }
const _hoisted_17 = { class: "forItem" }
const _hoisted_18 = {
  key: 1,
  class: "centerBox"
}
const _hoisted_19 = { class: "upload-text" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "点击上传", -1))
const _hoisted_21 = {
  key: 1,
  class: "imgBox"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_23 = { class: "editBox" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"12px","color":"#999"} }, "|", -1))
const _hoisted_25 = { class: "span" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "支持PNG或JPG格式，大小应小于5M", -1))
const _hoisted_27 = { class: "forItem" }
const _hoisted_28 = { class: "forItem" }
const _hoisted_29 = { class: "forItem" }
const _hoisted_30 = { class: "forItem" }
const _hoisted_31 = { class: "forItem" }
const _hoisted_32 = { class: "forItem" }
const _hoisted_33 = {
  class: "textarea",
  style: {"height":"auto"}
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {} }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PictureOutlined = _resolveComponent("PictureOutlined")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_Image = _resolveComponent("Image")!
  const _component_EyeFilled = _resolveComponent("EyeFilled")!
  const _component_EditFilled = _resolveComponent("EditFilled")!
  const _component_Form_item = _resolveComponent("Form-item")!
  const _component_LoadingOutlined = _resolveComponent("LoadingOutlined")!
  const _component_Input = _resolveComponent("Input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "营业执照",
              style: {"position":"relative","margin-bottom":"32px"}
            }, {
              default: _withCtx(() => [
                (!_ctx.datalist.imgFlagLicense && _ctx.notUploaded)
                  ? (_openBlock(), _createBlock(_component_Upload, {
                      key: 0,
                      "file-list": _ctx.datalist.licensePhotoUpload,
                      "onUpdate:file-list": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.datalist.licensePhotoUpload) = $event)),
                      name: "file",
                      "list-type": "picture-card",
                      onChange: _ctx.handleChange,
                      "before-upload": _ctx.beforeUpload,
                      customRequest: _ctx.customRequest,
                      showUploadList: false
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_PictureOutlined, { style: {"font-size":"20px"} }),
                          _hoisted_5
                        ])
                      ]),
                      _: 1
                    }, 8, ["file-list", "onChange", "before-upload", "customRequest"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_Image, {
                        class: "previewPhoto2",
                        style: {"width":"240px","height":"140px","object-fit":"cover"},
                        src: _ctx.firstImg || _ctx.datalist.licensePhoto
                      }, null, 8, ["src"]),
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", {
                          class: "span",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previewImg && _ctx.previewImg(...args)))
                        }, [
                          _createVNode(_component_EyeFilled),
                          _createTextVNode(" 查看 ")
                        ]),
                        _hoisted_9,
                        _createVNode(_component_Upload, {
                          class: "notUpload",
                          "file-list": _ctx.datalist.doorPhotoUpload,
                          "onUpdate:file-list": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.datalist.doorPhotoUpload) = $event)),
                          name: "file",
                          onChange: _ctx.handleChange,
                          "before-upload": _ctx.beforeUpload,
                          customRequest: _ctx.customRequest,
                          showUploadList: false
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_10, [
                              _createVNode(_component_EditFilled),
                              _createTextVNode(" 编辑 ")
                            ])
                          ]),
                          _: 1
                        }, 8, ["file-list", "onChange", "before-upload", "customRequest"])
                      ])
                    ])),
                _hoisted_11
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createVNode(_component_LoadingOutlined, { class: "icon" }, null, 512), [
                [_vShow, _ctx.iconShow]
              ]),
              _createVNode(_component_Form_item, {
                label: "统一社会信用代码",
                name: "licenseCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Input, {
                    value: _ctx.datalist.licenseCode,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.datalist.licenseCode) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createVNode(_component_LoadingOutlined, { class: "icon" }, null, 512), [
                [_vShow, _ctx.iconShow]
              ]),
              _createVNode(_component_Form_item, {
                label: "经营者",
                name: "licenseName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Input, {
                    value: _ctx.datalist.licenseName,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.datalist.licenseName) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createVNode(_component_LoadingOutlined, { class: "icon" }, null, 512), [
                [_vShow, _ctx.iconShow]
              ]),
              _createVNode(_component_Form_item, {
                label: "经营场所",
                name: "licenseAddress"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Input, {
                    value: _ctx.datalist.licenseAddress,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.datalist.licenseAddress) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createVNode(_component_LoadingOutlined, { class: "icon" }, null, 512), [
                [_vShow, _ctx.iconShow]
              ]),
              _createVNode(_component_Form_item, {
                label: "注册日期",
                name: "licenseDay"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Input, {
                    value: _ctx.datalist.licenseDay,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.datalist.licenseDay) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createVNode(_component_LoadingOutlined, { class: "icon" }, null, 512), [
                [_vShow, _ctx.iconShow]
              ]),
              _createVNode(_component_Form_item, {
                label: "执照类型",
                name: "licenseType"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Input, {
                    value: _ctx.datalist.licenseType,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.datalist.licenseType) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createVNode(_component_LoadingOutlined, { class: "icon" }, null, 512), [
                [_vShow, _ctx.iconShow]
              ]),
              _createVNode(_component_Form_item, {
                label: "有效期",
                name: "licenseExpiry"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Input, {
                    value: _ctx.datalist.licenseExpiry,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.datalist.licenseExpiry) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_Form_item, {
              label: "经营范围",
              name: "licenseScope",
              class: "forItem",
              style: {"margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_LoadingOutlined, { class: "lastIcon" }, null, 512), [
                  [_vShow, _ctx.iconShow]
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.datalist.licenseScope) = $event)),
                  maxlength: "200",
                  placeholder: "",
                  class: "textarea"
                }, null, 512), [
                  [_vModelText, _ctx.datalist.licenseScope]
                ])
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", null, [
            _createVNode(_component_Form_item, {
              class: "formItem",
              label: "营业执照",
              style: {"position":"relative","margin-bottom":"32px"}
            }, {
              default: _withCtx(() => [
                (!_ctx.datalist.imgFlagLicense && _ctx.notUploaded)
                  ? (_openBlock(), _createBlock(_component_Upload, {
                      key: 0,
                      "file-list": _ctx.datalist.licensePhotoUpload,
                      "onUpdate:file-list": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.datalist.licensePhotoUpload) = $event)),
                      name: "file",
                      "list-type": "picture-card",
                      onChange: _ctx.handleChange,
                      "before-upload": _ctx.beforeUpload,
                      customRequest: _ctx.customRequest,
                      showUploadList: false,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_PictureOutlined, { style: {"font-size":"20px"} }),
                          _hoisted_20
                        ])
                      ]),
                      _: 1
                    }, 8, ["file-list", "onChange", "before-upload", "customRequest"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_Image, {
                        class: "previewPhoto2",
                        style: {"width":"240px","height":"140px","object-fit":"cover"},
                        src: _ctx.firstImg || _ctx.datalist.licensePhoto
                      }, null, 8, ["src"]),
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", {
                          class: "span",
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.previewImg && _ctx.previewImg(...args)))
                        }, [
                          _createVNode(_component_EyeFilled),
                          _createTextVNode(" 查看 ")
                        ]),
                        _hoisted_24,
                        _createVNode(_component_Upload, {
                          class: "notUpload",
                          "file-list": _ctx.datalist.doorPhotoUpload,
                          "onUpdate:file-list": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.datalist.doorPhotoUpload) = $event)),
                          name: "file",
                          onChange: _ctx.handleChange,
                          "before-upload": _ctx.beforeUpload,
                          customRequest: _ctx.customRequest,
                          showUploadList: false,
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_25, [
                              _createVNode(_component_EditFilled),
                              _createTextVNode(" 编辑 ")
                            ])
                          ]),
                          _: 1
                        }, 8, ["file-list", "onChange", "before-upload", "customRequest"])
                      ])
                    ])),
                _hoisted_26
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_Form_item, { label: "统一社会信用代码" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.datalist.licenseCode), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_Form_item, { label: "经营者" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.datalist.licenseName), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_Form_item, { label: "经营场所" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.datalist.licenseAddress), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_Form_item, { label: "注册日期" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.datalist.licenseDay), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_Form_item, { label: "执照类型" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.datalist.licenseType), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_32, [
              _withDirectives(_createVNode(_component_LoadingOutlined, { class: "icon" }, null, 512), [
                [_vShow, _ctx.iconShow]
              ]),
              _createVNode(_component_Form_item, { label: "有效期" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.datalist.licenseExpiry), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_Form_item, {
              label: "经营范围",
              class: "forItem",
              style: {"margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.datalist.licenseScope), 1)
              ]),
              _: 1
            })
          ])
        ])),
    _hoisted_34
  ]))
}